<template>
  <div></div>
</template>

<script>
import mixin from '@/mixin';
import { updateToken } from '@/router/index';
import networkController from '@/api/networkController';
import throttle from 'lodash/throttle';

// Seconds
const A_MINUTE = 60;
const AN_HOUR = 3600;
const IDLE_DURATION = 8;
const TEST_TIME_UNIT = toMillisec(AN_HOUR)
function toMillisec (num) {return num * 1000;}

export default {
	mixins: [mixin.common],
  data() {
    return {
      duration: IDLE_DURATION,
      userConfig: { // Milliseconds
        autoTimeout: 0,
        inactiveTimeout: 0,
      },
      idleStopTime: 0, // Milliseconds
      idleTimer: 0,
      logoutMonitor: 0,
      checkValidIPTimer: 0,
      isActive: true,
      logoutTimeFromLogin: 0,
      logoutTimeFromIdle: 0,
      loginTime:0,
    }
  },
	computed:{
    newUserConfig() {
      return this.$store.getters.getUserConfig;
    },
  },
  watch:{
    newUserConfig(newValue) {
      this.userConfig.autoTimeout = toMillisec(newValue.autoTimeout * 60);
      this.userConfig.inactiveTimeout = toMillisec(newValue.inactiveTimeout * 60);
      // console.log( `🌈 newUserConfig : ${newValue.autoTimeout}분 뒤 자동 로그아웃 | 비활성 ${newValue.inactiveTimeout}분 뒤 로그아웃` );
    },
    isActive() {
      if (this.isActive) {
        this.idleTimer = setInterval(() => {
          this.duration--;
          // console.log('[RE] idleTime COUNT');
        }, 1000);
      }
      if (!this.isActive) {
        clearInterval(this.idleTimer);
        this.duration = IDLE_DURATION;
        this.idleStopTime = this.getKrTimeMillisec(new Date());
        // console.log(`idleStopTime : ${new Date(this.idleStopTime)}`)
      }
    },
    duration() {
      if (this.duration === 0) {
        this.isActive = false;
        this.idleStopTime = this.getKrTimeMillisec(new Date());
        clearInterval(this.idleTimer);
        // console.log(`🐽 비활성 로그아웃 예정 시간: ${new Date(this.idleStopTime + this.userConfig.inactiveTimeout)}`)
      }
    },
  },
  created (){
    this.loginTime = this.$store.state.userData.loginTime || Date.now(); // Milliseconds
    this.userConfig.autoTimeout = this.$store.getters.getUserConfig.autoTimeout * 60 * 1000;
    this.userConfig.inactiveTimeout = this.$store.getters.getUserConfig.inactiveTimeout * 60 * 1000;
  },
  mounted (){
    console.log(`🚀 로그인 시간 ${new Date(this.loginTime)}`)  
    console.log(`👩🏻 userConfig 설정값) 자동: ${this.userConfig.autoTimeout/60/1000}분 | 비활성: ${this.userConfig.inactiveTimeout/60/1000}분`)
    console.log(`⭐️ 자동 로그아웃 예정 시간: ${new Date(this.loginTime + this.userConfig.autoTimeout)}`)

    this.detectMotion();
    this.keepSessionAlive();

    this.idleTimer = setInterval(() => {
      this.duration--;
    }, 1000);

    this.logoutMonitor = setInterval(() => {
      const now = this.getKrTimeMillisec(new Date())
      if ( now > (this.loginTime + this.userConfig.autoTimeout)) {
        this.logout();
        return;
        }
      if(this.idleStopTime){
        if ( now > (this.idleStopTime + this.userConfig.inactiveTimeout)) {
          this.logout();
          return;
          }
      }
    }, A_MINUTE*1000);

    const user = this.$store.getters.getUser;
    if (user.whitelistTarget) {
      console.log('Whitelist 체크 대상입니다. 1분 루틴 시작합니다.');
      this.checkValidIp();
      this.checkValidIPTimer = setInterval(this.checkValidIp, A_MINUTE*1000);
    }
  },
  beforeDestroy (){
    clearInterval(this.idleTimer);
    clearInterval(this.logoutMonitor);
    clearInterval(this.checkValidIPTimer);
  },
  methods: {
    logout() {
      let router_data = {
        fromLogout: true,
        autoLogout: true,
      };

      this.$store.commit('setUser', {});
      this.$store.commit('setAdmin', {});
			sessionStorage.clear();
      localStorage.removeItem('auth');
      this.$router.push({ name: 'login', params: router_data });
      this.$dialog.info({
				icon: false,
        title: this.t('timeoutLogout'),
        text: this.t('timeoutLogoutContent'),
      });
    },
    logoutInvalidIP() {
      this.$dialog.message.error(this.t('invalidIPLogoutContent'), {position: 'top', timeout: 2000});

      // 2초 후에 로그아웃 로직을 실행
      setTimeout(() => {
        let router_data = {
          fromLogout: true,
          autoLogout: true,
        };

        this.$store.commit('setUser', {});
        this.$store.commit('setAdmin', {});
        sessionStorage.clear();
        localStorage.removeItem('auth');
        this.$router.push({ name: 'login', params: router_data });
      }, 2000); // 2000밀리초(2초) 후에 실행
    },
    async checkValidIp() {
      try {
        const result = await networkController.checkValidIp({});

        // 결과를 테이블 형태로 콘솔에 출력
        console.table(result.data);

        // 결과가 유효하지 않으면 로그아웃 처리
        if (!result.data.result) {
          console.warn("유효하지 않은 IP. 로그아웃 처리됩니다.");
          this.logoutInvalidIP();
        }
      } catch (error) {
        // 에러가 발생했을 때의 처리
        console.error("IP 유효성 검사 중 오류 발생:", error);
        this.logoutInvalidIP();
      }
    },
    detectMotion (){
      document.getElementById('ueyes_app').addEventListener(
        'mousemove',
        throttle(() => {
          this.isActive = true;
          this.duration = IDLE_DURATION;
        }, 1000)
      );
      document.getElementById('ueyes_app').addEventListener(
        'click',
        throttle(() => {
          this.isActive = true;
          this.duration = IDLE_DURATION;
        }, 1000)
      );
    },
    keepSessionAlive (){
      setInterval(() => {
        if (sessionStorage.getItem('auth')) {
          const refresh = updateToken();
        }
      }, AN_HOUR * 2 * 1000);
    },
    getKrTimeMillisec (dateObj){
      if(typeof dateObj !== 'object') 
        throw new Error('getKrTimeMillisec의 인자로 데이트 객체를 넣어주세요.')
      const utc = dateObj.getTime() + toMillisec(dateObj.getTimezoneOffset() * A_MINUTE);
      return toMillisec(AN_HOUR * 9) + utc;
    },
  },
}
</script>